import { Component, OnInit } from '@angular/core';
import {Subscription, take} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import { CustomerService } from '../services/customer/customer.service';
import { UserService } from '../services/user/user.service';
import { Title } from '@angular/platform-browser';
import {GetMaintenanceGQL, GetMaintenanceQuery} from '../../generated/graphql';
import {CustomerServiceImpl} from "../services/customer/customer.service.impl";

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

    public isUserCreated = false;
    public loading = false
    subs: Subscription[] = [];
    maintenanceData: GetMaintenanceQuery['getMaintenance'] | undefined = undefined

    constructor(
        private customerService: CustomerService,
        private userService: UserService,
        private route: ActivatedRoute,
        private titleService: Title,
        protected router: Router,
        private getMaintenanceGQL: GetMaintenanceGQL
    ) { }

    ngOnInit() {
        this.customerService.loadCustomer();
        this.subs.push(this.route.queryParamMap.subscribe(async () => {
            if (!this.isUserCreated) {
                await this.userService.createUserIfNotExists();
            }
            this.loading = true;

          this.getMaintenanceGQL.fetch().pipe(take(1)).subscribe({
            next: (response) => {
              const responseMaintenanceMode = response?.data?.getMaintenance || undefined;

              const currentCustomer = CustomerServiceImpl.GetCustomerKey();
              const maintenanceModeActiveForCurrentCustomer = responseMaintenanceMode?.customers
                .map(c => c.key)
                .includes(currentCustomer);

              if (maintenanceModeActiveForCurrentCustomer) {
                this.maintenanceData = responseMaintenanceMode;
                if (this.maintenanceData?.title) {
                  this.titleService.setTitle(this.maintenanceData.title);
                }
              } else {
                this.router.navigateByUrl('').then();
              }
            },
            error: (err) => {
              console.error('Error fetching maintenance info', err);
            },
            complete: () => {
              this.loading = false; // End loading
            }
          });
        }));
    }
}
